
import * as defaultImport from "prop-types";
export * from "prop-types";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
